import { useCallback } from "react";
import { FormHandles } from "@unform/core";
import * as Yup from "yup";

import { InputTypes } from "../UserData.screen";
import { getValidationErros } from "../../../../Utils";
import { useManipulateStepProposal } from "../../services";

import { reduceFormErrors } from "./signUp.reduceFormErrors";
import { setStatusInInput, setErrorInInput } from "./signUp.form";

interface SubmitSendStepProposal {
  name: InputTypes;
  formatField(value: string): { [key in string]: string };
  stepToFillProposal: string;
  stepProposalFilled: string;
  validateSuccess: { step: string; status: string };
  setEnableNextInput?(): void;
  focusNextInput?(): void;
  validateInput(fieldsFormData: Record<string, any> | undefined): Promise<void>;
  formRef: React.RefObject<FormHandles>;
  proposalId: string | null;
  stepFieldId: string | null;
  setStepFieldId(stepFieldId: string | null): void;
  errorMessage: string;
  openModal?(): void;
  setDisabledField?(): void;
}

interface UseHandleStepProposalReturn {
  handleSendStepProposal(params: SubmitSendStepProposal): () => Promise<void>;
}

interface BuildMutationParams {
  proposalId?: string | null;
  stepToFillProposal?: string;
  stepFieldId: string | null;
  fields: { [x: string]: string };
  type: "send" | "update";
}

interface StepProps {
  id: string;
  step?: string;
  created_at: string;
}

export const useHandleStepProposal = (): UseHandleStepProposalReturn => {
  const { manipulateStepProposal } = useManipulateStepProposal();

  function buildMutationParams(params: BuildMutationParams) {
    const variables: any = {
      proposal_id: params?.proposalId,
      ...params?.fields,
    };

    if (params?.type === "send") {
      variables.step = params?.stepToFillProposal;
      return variables;
    }

    if (params?.type === "update") {
      variables.step_id = params?.stepFieldId;
      return variables;
    }
  }

  const handleSendStepProposal = useCallback(
    ({
        name,
        formatField,
        stepToFillProposal,
        validateSuccess,
        setEnableNextInput,
        validateInput,
        focusNextInput,
        formRef,
        proposalId,
        errorMessage,
        openModal,
        stepFieldId,
        setStepFieldId,
        stepProposalFilled,
        setDisabledField,
      }: SubmitSendStepProposal) =>
      async (): Promise<void> => {
        const type = stepFieldId ? "update" : "send";
        const formFields = formRef?.current?.getData();

        try {
          await validateInput(formFields);
          setStatusInInput({ formRef, inputName: name, type: "loading" });

          if (!proposalId) {
            console.log("proposal id null===");
            setErrorInInput({ formRef, inputName: name, errorMessage });
            return;
          }

          const field = formFields?.[name] || "";

          const variables: any = buildMutationParams({
            fields: formatField(field),
            stepFieldId,
            type,
            proposalId,
            stepToFillProposal,
          });

          console.log("variables", variables);

          const response = await manipulateStepProposal({
            variables,
            type,
          });

          console.log(response);
          const status = response?.status;
          const step = response?.step;
          const steps = response?.steps;

          if (
            (status === validateSuccess.status &&
              step === validateSuccess.step) ||
            type === "update"
          ) {
            setStatusInInput({ formRef, inputName: name, type: "success" });

            console.log("steps", steps);
            console.log("stepProposalFilled", stepProposalFilled);
            if (setStepFieldId) {
              const stepId = steps?.find(
                ({ step }: StepProps) => step === stepProposalFilled
              )?.id;
              if (stepId) {
                setStepFieldId(stepId);
              }
            }

            if (name === "cell_phone_number" && openModal) {
              openModal();
              return;
            }

            if (name === "birthdate" && type !== "update" && setDisabledField) {
              setDisabledField();
            }

            if (type !== "update" && setEnableNextInput) {
              setEnableNextInput();
            }

            if (focusNextInput) {
              focusNextInput();
            }

            return;
          }

          setErrorInInput({ errorMessage, formRef, inputName: name });
        } catch (error: any) {
          console.log("Deu erro", { error });
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErros(error);
            formRef.current?.setErrors(reduceFormErrors(formRef, errors));
          }
        }
      },
    [manipulateStepProposal]
  );

  return { handleSendStepProposal };
};
